import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface Conclave {
  id: number;
  user_id?: number;
  title: string;
  description?: string | null;
  venue?: string | null;
  city?: string | null;
  state?: string | null;
  no_of_days?: number;
  start_date?: string;
  start_time?: string;
  end_date?: string;
  end_time?: string;
  ticket_type?: string | null;
  price_per_head?: string | null;
  participant_type?: string | null;
  registerion_link?: string | null;
  registration_deadline_date?: string | null;
  cover_image_url?: string | null;
  selected_groups?: (string | number)[];
  is_active?: boolean;
}

export interface ConclaveListResponse {
  status: string;
  message: string;
  data: Conclave[];
}

@Injectable({
  providedIn: 'root'
})
export class ConclaveApiService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private readonly http: HttpClient) {}

  // CREATE CONCLAVE (supports multipart/form-data)
  createConclave(payload: FormData | any): Observable<any> {
    return this.http.post(`${this.apiUrl}conclave`, payload);
  }

  // GET ALL GROUPS (ONLY FOR CONCLAVE MODULE)
  getAllGroups(): Observable<any> {
    return this.http.get(
      `${this.apiUrl}group/get-all?page=1&per_page=1000`
    );
  }

  // GET CONCLAVES BY YEAR e.g. /conclave?year=2026
  fetchConclavesByYear(year: number | string): Observable<ConclaveListResponse> {
    return this.http.get<ConclaveListResponse>(`${this.apiUrl}conclave?year=${year}`);
  }
  // GET CONCLAVE BY ID
  getConclaveById(id: number | string): Observable<{ status: string; message: string; data: Conclave }> {
    return this.http.get<{ status: string; message: string; data: Conclave }>(
      `${this.apiUrl}conclave/${id}`
    );
  }
}

